<template>
    <div class="row">
        <div :class="selectedWarehouse ? 'col-lg-9' : 'col-lg-12'">
            <div class="card stretch stretch-full">
                <div class="card-header">
                    <h5 class="card-title">İlaç Deposu Listesi</h5>
                    <div class="card-header-action">
                        <div class="card-header-btn">
                            <div data-bs-toggle="tooltip" title="Yenile">
                                <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                    data-bs-toggle="refresh"> </button>
                            </div>
                            <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                                <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                    data-bs-toggle="expand"> </a>
                            </div>
                        </div>
                        <div class="dropdown">
                            <a href="javascript:void(0);" class="avatar-text avatar-sm" data-bs-toggle="dropdown"
                                data-bs-offset="25, 25">
                                <div data-bs-toggle="tooltip" title="Seçenekler">
                                    <i class="feather-more-vertical"></i>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <router-link to="/warehouse/add" class="dropdown-item"><i
                                        class="feather-plus-circle"></i>Yeni
                                    Ekle</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body custom-card-action p-0">
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Depo Adı</th>
                                    <th scope="col" v-if="!selectedWarehouse">Konumu</th>
                                    <th scope="col" v-if="!selectedWarehouse">Açıklama</th>
                                    <th scope="col">İlaç Sayısı</th>
                                    <th scope="col">Varsayılan</th>
                                    <th scope="col">Aktif</th>
                                    <th scope="col" class="text-end">İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="warehouse in warehousess" :key="warehouse.id"
                                    :class="{ 'table-active': warehouse === selectedWarehouse }">
                                    <td>
                                        <router-link :to="{ name: 'WarehouseEdit', params: { id: warehouse.id } }"
                                            class="d-block mb-1">{{ warehouse.name }}</router-link>
                                    </td>
                                    <td v-if="!selectedWarehouse">{{ warehouse.location }}</td>
                                    <td v-if="!selectedWarehouse">{{ warehouse.description }}</td>
                                    <td>{{ warehouse.medicine_count }}</td>
                                    <td>{{ warehouse.default ? 'Evet' : 'Hayır' }}</td>
                                    <td>{{ warehouse.active ? 'Evet' : 'Hayır' }}</td>
                                    <td>
                                        <div class="hstack gap-2 justify-content-end">
                                            <button class="avatar-text avatar-md bg-blue text-white"
                                                @click="selectWarehouse(warehouse)">
                                                <i class=" feather-list fs-16"></i>
                                            </button>
                                            <router-link :to="{ name: 'WarehouseEdit', params: { id: warehouse.id } }"
                                                class="avatar-text avatar-md bg-orange">
                                                <i class="feather-eye fs-16"></i>
                                            </router-link>
                                            <a href="#" @click="deleteWarehouse(warehouse.id)"
                                                class="avatar-text avatar-md bg-red">
                                                <i class="feather-delete fs-16"></i>
                                            </a>

                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <Pagination :currentPage="currentPage" :totalPages="totalPages" :next="next" :previous="previous"
                        @page-changed="fetchData" />
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="row">
                <div class="col-lg-12" v-if="selectedWarehouse">
                    <div class="card stretch stretch-full">
                        <div class="card-header">
                            <h5 class="card-title"><span class="text-danger">[{{ selectedWarehouse.name }}]</span><br>
                                İlaç
                                Bakiyeleri</h5>
                            <div class="card-header-action">
                                <div class="card-header-btn">
                                    <div data-bs-toggle="tooltip" title="Kapat">
                                        <button @click="selectedWarehouse = null"
                                            class="avatar-text avatar-xs bg-danger">
                                        </button>
                                    </div>

                                    <div data-bs-toggle="tooltip" title="Yenile">
                                        <button @click="selectWarehouse(selectedWarehouse)"
                                            class="avatar-text avatar-xs bg-warning" data-bs-toggle="refresh"> </button>
                                    </div>
                                    <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                                        <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                            data-bs-toggle="expand"> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body custom-card-action p-0">
                            <div class="table-responsive">
                                <table class="table mb-0 table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">İlaç Adı</th>
                                            <th scope="col">Bakiyesi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="medicineInWarehouse in medicinesInWarehouse"
                                            :key="medicineInWarehouse.warehouse_id"
                                            @click="selectedMedicine = medicineInWarehouse"
                                            :class="{ 'table-active': medicineInWarehouse === selectedMedicine }"
                                            :style="{ cursor: !selectedMedicine || selectedMedicine != medicineInWarehouse ? 'pointer' : 'default' }">
                                            <td>
                                                {{ medicineInWarehouse.medicine_name }}
                                            </td>
                                            <td>{{ medicineInWarehouse.quantity }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" col-lg-12" v-if="selectedMedicine">
                    <WarehouseStockListByExpirationDate v-if="selectedMedicine" @close-card="selectedMedicine = null"
                        :warehouseId="selectedWarehouse.id" :medicineId="selectedMedicine.medicine_id" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Pagination from '@/components/common/Pagination.vue';
import WarehouseStockListByExpirationDate from '@/components/medicine/WarehouseStockListByExpirationDate.vue';


export default {
    name: 'WarehouseTable',
    components: {
        Pagination,
        WarehouseStockListByExpirationDate,
    },
    data() {
        return {
            warehousess: [],
            medicinesInWarehouse: [],
            currentPage: 1,
            totalPages: 1,
            next: true,
            previous: false,
            selectedWarehouse: null,
            selectedMedicine: null,
        }
    },
    async mounted() {
        const page = Number(this.$route.params.page) || 1;
        await this.fetchData(page);
    },
    watch: {
        '$route.params.page'(newPage) {
            this.fetchData(Number(newPage));
        }
    },
    methods: {
        async selectWarehouse(warehouse) {
            this.selectedWarehouse = warehouse;
            console.log('warehouse :', this.selectedWarehouse);
            await this.$axios.get(`warehouse-stock/?warehouse_id=${warehouse.id}`).then(response => {
                console.log('response :', response.data);
                this.medicinesInWarehouse = response.data;
                console.log(this.medicinesInWarehouse);
            });
        },
        async fetchData(page = 1) {
            console.log('fetch data called');
            try {
                const response = await this.$axios.get(`warehouse/?page=${page}`);
                console.log('response:', response.data);
                this.warehousess = response.data.results;
                this.totalPages = Math.ceil(response.data.count / 10);
                this.currentPage = page;
                this.next = response.data.next;
                this.previous = response.data.previous;
            } catch (error) {
                Swal.fire('Hata!', `${error}`, 'error');
            }
        },
        async deleteWarehouse(id) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Bu işlem geri alınamaz!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    await this.$axios.delete(`warehouse/${id}/`);
                    Swal.fire("Başarılı!", "Kayıt silindi.", "success");

                    // this.shelters.splice(this.shelters.findIndex(shelter => shelter.id === id), 1);
                    this.fetchData();
                } catch (err) {
                    Swal.fire("Hata!", "Silme işlemi başarısız.", "error");
                    console.error(err);
                }
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>